/* eslint-disable */
import React from "react";
import Main from "./components/Main";
import "./App.css";

const App: React.FC = (): JSX.Element => {
  return (
    <div>
      <Main />
    </div>
  );
};

export default App;
